"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        height: 350,
    },
};
var description = 'This is how you get it if you don\'t pass any props. ' +
    'You can see just the expand icon, but when you click, it expands, showing its subitems.';
var code = "import React from 'react';\nimport { Drawer, DrawerSubitemsContainer,DrawerItem } from 'jsc-react-ui';\n\nconst style = {\n  height: 350,\n};\n\nconst DrawerItemExample = () => (\n  <Drawer style={style}>\n    <DrawerSubitemsContainer>\n      <DrawerItem text=\"Files\" subitem />\n    </DrawerSubitemsContainer>\n  </Drawer>\n);";
exports.RawExampleDrawerSubitemsContainer = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Drawer, { style: componentStyle.base },
        React.createElement(components_1.DrawerSubitemsContainer, null,
            React.createElement(components_1.DrawerItem, { text: "Files", subitem: true }))))); };
exports.RawExampleDrawerSubitemsContainer.displayName = 'RawExampleDrawerSubitemsContainer';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerSubitemsContainerPage/RawExampleDrawerSubitemsContainer.tsx
// module id = 664
// module chunks = 0